import React, { useState } from "react";
import { globalFileServer } from "../../../../axiosInstance";
import ProductInfo from "../../productInfo/ProductInfo";

const Detailes = ({
  element,
  familyProd = false,
  inCart,
  productPopUp,
  comparePricesPopUp,
  srcPrev,
}) => {
  const mediaArray = Array.isArray(element?.media) ? element.media : [];

  const [mediaIndex, setMediaIndex] = useState(
    mediaArray.length > 0 ? mediaArray.length - 1 : -1,
  );
  if (!element) return null;
  const handleError = () => {
    if (mediaIndex > 0) {
      setMediaIndex((prev) => prev - 1);
    } else {
      setMediaIndex(-1);
    }
  };

  const imageSrc =
    srcPrev != null
      ? srcPrev
      : mediaIndex >= 0 && mediaArray[mediaIndex]?.path
        ? `${globalFileServer}products/${mediaArray[mediaIndex].path}?width=150&height=150`
        : `${globalFileServer}placeholder.jpg`;

  const hasPromotion = element.pricing?.promotions?.length > 0;

  return (
    <div className="item-card-details" onClick={productPopUp}>
      <div
        className={
          inCart
            ? "card-img-in-card"
            : element.availability.availableQuantity > 0
              ? "card-img"
              : "regular-card"
        }
        style={srcPrev ? { width: "190px" } : undefined}
      >
        <img
          className="img"
          loading="lazy"
          src={imageSrc}
          onError={handleError}
          alt={element.name || "product"}
        />
      </div>

      <div className="desc">
        <span className="product-info">
          <ProductInfo selectedProd={element} familyProd={familyProd} />
        </span>
        <div className="kosher-and-price">
          {hasPromotion &&
            element.pricing.promotions[0].promoType === "FLAT" && (
              <span className="current-price">
                {element.pricing.promotions[0].discountValue}
              </span>
            )}
          {!familyProd && (
            <div className="price-main-cont">
              {element.pricing?.price != null && (
                <span
                  className={
                    hasPromotion &&
                    element.pricing.promotions[0].promoType !== "QUANTITY_PRICE"
                      ? "price with-sale"
                      : "current-price"
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    comparePricesPopUp?.();
                  }}
                  data-tip
                  data-for="registerTipComparePrice"
                >
                  {element.pricing.price}
                </span>
              )}
            </div>
          )}

          {element.kosherSupervision?.length > 0 &&
            element.kosherSupervision[0].supervisionAgency &&
            element.kosherSupervision[0]?.supervisionAgency.img?.path !==
              "19.svg" && (
              <div className="prod-info-kosher">
                {/* <img
                  loading="lazy"
                  src={
                    globalFileServer +
                    "iconcss/" +
                    element.kosherSupervision[0].supervisionAgency.img.path
                  }
                  alt={
                    element.kosherSupervision[0].supervisionAgency?.name ||
                    "kosher"
                  }
                /> */}
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default Detailes;
